<header>
  <nav class="navbar px-0">
    <div class="mt-2">
      <ul class="navbar-nav flex-grow">
        <li class="nav-item" [routerLinkActive]="['link-active']">
          <a class="btn btn-outline-dark" (click)="redirectHome()">Back</a>
        </li>
      </ul>

    </div>

    <div class="mt-2">
      <label class="my-1 me-2 fw-bold" for="dateperiod">Select Grading Period</label>
      <select class="custom-select my-1 mr-sm-2" id="dateperiod" [(ngModel)]="selectedGP" (change)="OnChangeGradingPeriod();" required>
        <option *ngFor="let gpo of gradingperiodobj" value={{gpo.schoolTermGradingPeriodId}}>{{gpo.gradingPeriod}}</option>
      </select>
    </div>

  </nav>
</header>

<div class="row">
  <div class="col-12">
    <p-table #dth [value]="statusLogdata" dataKey="processId" [loading]="loading"
             [autoLayout]="true"
             [expandedRowKeys]="expandedRowsHistory" (onRowExpand)="onRowExpand($event)">

      <ng-template pTemplate="header">
        <tr [style.display]="!loading ? 'table-row' : 'none'">

          <th #sourceTh class="student-name">Submission Status</th>
          <th #sourceTh class="gradebook-grade">Published Time</th>
          <th #sourceTh class="gradebook-grade">Total Submissions</th>
          <th #sourceTh class="gradebook-grade">Successful</th>
          <th #sourceTh class="gradebook-grade">Failed</th>
          <th #sourceTh class="gradebook-grade">Failure Percent</th>
          <th #sourceTh style="width:175px" class="grade-override text-nowrap form-horizontal"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-log let-expanded="expanded">
        <tr class="spacer">
          <td colspan="8"></td>
        </tr>
        <tr class="main-level bg-white shadow-sm">

          <td class="student-name">

            <a href="#" class="" [pRowToggler]="log">
              {{log.submissionStatus}}
              <i class="pi" [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
            </a>
          </td>
          <td class="gradebook-grade">{{log.publishedTime }}</td>
          <td class="gradebook-grade">{{log.totalStudentCount}}</td>
          <td class="gradebook-grade">{{log.successStudentCount }}</td>
          <td class="gradebook-grade">{{log.failedStudentCount }}</td>
          <td class="gradebook-grade">{{log.failurePercent }}</td>
        </tr>
      </ng-template>


      <ng-template pTemplate="rowexpansion" let-log>
        <tr class="child-level">
          <td colspan="8">
            <div class="p-0">
              <p-table [value]="log.lstLogStudentDetails" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th class="student-name" style="width:50%">
                      Failed Submissions
                    </th>
                    <th class="student-name" style="width:50%">
                      Successful Submissions
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-sp let-expanded="expanded">
                  <tr>
                    <td>                      
                        <span *ngIf="sp.responseCode !== '200'">                          
                          {{ sp.studentName }}
                        </span>                      
                    </td>
                    <td>                      
                      <span *ngIf="sp.responseCode == '200'">
                        {{ sp.studentName }}
                      </span>                      
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>

